<template>
  <v-toolbar
    class="user-toolbar"
    color="white"
    clipped-left
    app
  >
    <img
      class="logo"
      src="/static/images/base/new-docgo-logo.svg"
      width="100"
      @click="goToHomePage"
    />
    <v-spacer></v-spacer>
    <global-search-text-field v-show="showSearch" showSearch="showSearch"/>
    <v-layout justify-start class="pt-3 ml-2">
      <search-all-folders v-show="showGeneralSearch()"/>
    </v-layout>

    <v-spacer></v-spacer>

    <v-menu
      v-if="userAdministrativeUnits.length > 0"
      offset-y
      transition="slide-y-transition"
    >
      <v-btn
        flat
        slot="activator"
        class="admin-unit-selector"
      >
        <v-icon left>mdi-domain</v-icon>
        <v-chip
          small
          class="mr-2 admin-unit-badge admin-unit-badge--main"
          :style="{
            color: getAdminUnitColor(userAdministrativeUnits.find(u => u.id === selectedAdministrativeUnit)),
            borderColor: getAdminUnitColor(userAdministrativeUnits.find(u => u.id === selectedAdministrativeUnit)),
            backgroundColor: 'transparent'
          }"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="truncate-text">{{ getCurrentAdminUnitName() }}</span>
            </template>
            <span>{{ getCurrentAdminUnitFullName() }}</span>
          </v-tooltip>
        </v-chip>
        <v-icon right>mdi-chevron-down</v-icon>
      </v-btn>
      <v-list>
        <!-- Unidade Administrativa Principal -->
        <v-subheader class="grey--text text--darken-1">Unidade Principal</v-subheader>
        <v-list-tile
          v-if="getPrimaryUnit()"
          :key="getPrimaryUnit().id"
          @click="selectAdministrativeUnit(getPrimaryUnit().id)"
          :class="{'primary--text': selectedAdministrativeUnit === getPrimaryUnit().id}"
        >
          <v-list-tile-content>
            <v-list-tile-title >
              <v-chip
                small
                :outline="false"
                class="mr-2 admin-unit-badge admin-unit-badge--main"
                :style="{
                  color: getAdminUnitColor(getPrimaryUnit()),
                  borderColor: getAdminUnitColor(getPrimaryUnit()),
                  backgroundColor: 'transparent'
                }"
              >
                {{ getPrimaryUnit().abbreviation || getPrimaryUnit().name.substring(0, 3) }}
              </v-chip>
<!--              <span class="truncate-text primary-unit-name">{{ getPrimaryUnit().name }}</span>-->
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="selectedAdministrativeUnit === getPrimaryUnit().id">
            <v-icon color="primary">mdi-check</v-icon>
          </v-list-tile-action>
        </v-list-tile>

        <!-- Unidades Administrativas Secundárias -->
        <v-divider v-if="getSecondaryUnits().length > 0"></v-divider>
        <v-subheader v-if="getSecondaryUnits().length > 0" class="grey--text text--darken-1">Unidades Secundárias</v-subheader>
        <v-list-tile
          v-for="unit in getSecondaryUnits()"
          :key="unit.id"
          @click="selectAdministrativeUnit(unit.id)"
          :class="{'primary--text': selectedAdministrativeUnit === unit.id}"
        >
          <v-list-tile-content>
            <v-list-tile-title class="toolbar-title-custom" >
              <v-chip
                small
                outline
                class="mr-2 admin-unit-badge admin-unit-badge--main"
                :style="{
                  color: getAdminUnitColor(unit),
                  borderColor: getAdminUnitColor(unit),
                  backgroundColor: 'transparent'
                }"
              >
                {{ unit.abbreviation || unit.name.substring(0, 3) }}
              </v-chip>
<!--              <span class="truncate-text secondary-unit-name">{{ unit.name }}</span>-->
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="selectedAdministrativeUnit === unit.id">
            <v-icon color="primary">mdi-check</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-menu>

    <settings v-if="user && user.super_admin"></settings>
    <user-menu></user-menu>
    <!--    <user-notifications class="mx-2"></user-notifications>-->
  </v-toolbar>
</template>

<script>
  import SearchAllFolders from '@/components/base/SearchAllFolders';
  import UserNotifications from './UserNotifications';
  import UserMenu from './UserMenu';
  import Settings from './Settings';
  import GlobalSearchTextField from './GlobalSearchTextField';
  import { mapGetters } from 'vuex';
  import adminUnitHandling from '@/mixins/admin-unit-handling';
  import getColorByText from '@/assets/utils/colorByText';

  export default {
    name: 'user-toolbar',
    mixins: [adminUnitHandling],
    components: {
      GlobalSearchTextField,
      SearchAllFolders,
      UserMenu,
      UserNotifications,
      Settings,
    },
    data() {
      return {
        searchIsFocused: false,
      };
    },
    props: {
      showSearch: {
        default: true,
      },
    },
    methods: {
      expressionTest(item, value) {
        const expression = new RegExp(value, 'i');
        const propertyToSearch = 'name';
        return expression.test(item[propertyToSearch]);
      },
      goToHomePage() {
        window.location= '/';
      },
      showGeneralSearch() {
        var perm = this.user.permissions;
        if (perm) return perm.general_search;
        return false;
      },
      selectAdministrativeUnit(unitId) {
        const AdminUnitSwitchService = require('@/services/AdminUnitSwitchService').default;
        unitId = parseInt(unitId, 10);
        if (this.selectedAdministrativeUnit === unitId) {
          console.log('Mesma unidade administrativa já selecionada, ignorando...');
          return;
        }
        AdminUnitSwitchService.switchAdminUnit(unitId)
          .catch(error => {
            console.error('Erro ao trocar unidade administrativa:', error);
          });
      },
      getCurrentAdminUnitName() {
        if (!this.selectedAdministrativeUnit || !this.userAdministrativeUnits.length) return '';

        const unit = this.userAdministrativeUnits.find(u => u.id === this.selectedAdministrativeUnit);
        if (!unit) return '';

        if (unit.abbreviation) return unit.abbreviation;

        if (unit.name && unit.name.length > 10) {
          return unit.name.substring(0, 8) + '...';
        }

        return unit.name;
      },
      getCurrentAdminUnitFullName() {
        if (!this.selectedAdministrativeUnit || !this.userAdministrativeUnits.length) return '';

        const unit = this.userAdministrativeUnits.find(u => u.id === this.selectedAdministrativeUnit);
        return unit ? unit.name : '';
      },
      isPrimaryUnit(unitId) {
        if (!unitId || !this.user || !this.user.administrative_unit) return false;
        return this.user.administrative_unit.id === unitId;
      },
      getPrimaryUnit() {
        if (!this.user || !this.user.administrative_unit) return null;
        return this.user.administrative_unit;
      },
      getSecondaryUnits() {
        if (!this.userAdministrativeUnits || !this.userAdministrativeUnits.length) return [];
        if (!this.user || !this.user.administrative_unit) return this.userAdministrativeUnits;
        return this.userAdministrativeUnits.filter(unit => unit.id !== this.user.administrative_unit.id);
      },
      getAdminUnitColor(unit) {
        if (!unit) return '';
        return getColorByText(unit.name);
      },
      getFolderTypeColor(folderType) {
        return getColorByText(folderType.name);
      },
    },
    computed: {
      ...mapGetters(['selectedAdministrativeUnit', 'userAdministrativeUnits']),
      folders() {
        return this.$store.getters.folders;
      },
      user() {
        return this.$store.getters.user;
      },
    },
  };
</script>

<style lang="scss" scoped>
.toolbar-title-custom {
  height: 50px !important;
  line-height: 50px !important;
}
.user-toolbar {
  .logo {
   cursor: pointer;
  }
  .search-field {
    align-self: flex-end;
    color: inherit;

    .v-input__slot {
      border-radius: 24px;
    }
  }

  .admin-unit-badge {
    text-transform: uppercase !important;
    font-weight: 500 !important;
    letter-spacing: 0.5px !important;
    //max-width: 80px !important;
    //min-width: 100px !important;
  }

  // Estilo para evitar corte dos chips no menu de seleção
  .v-list-tile {
    height: auto !important;
    min-height: 48px !important;
    padding: 8px 16px !important;
  }

  .v-list-tile__title {
    height: auto !important;
    white-space: normal !important; // Permite quebra de linha
    display: flex !important;
    align-items: center !important;
    flex-wrap: wrap !important;
  }

  .truncate-text {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }

  .admin-unit-selector {
    max-width: 200px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user-toolbar/UserToolbar.vue